import { encodeUnicodeBase64 } from '@wix/ricos/schema-next';

import { PLAYGROUND_LINK } from './constants';
import type { PluginSettings } from './use-parsed-plugins';
import { defaultPluginSettings } from './use-parsed-plugins';

export const getLinkToPlayground = (content: string, plugins: PluginSettings): string => {
  const pluginPart =
    defaultPluginSettings.editor === plugins.editor ? '' : `?plugins=${plugins.editor.join('.')}`;
  const contentPart = `#content=${encodeUnicodeBase64(content)}`;
  return `${PLAYGROUND_LINK}${pluginPart}${contentPart}`;
};
